<div class="row">
  <form class="mt-2" [formGroup]="form">
    <h2>
      Dati per credenziali di accesso
    </h2>
    <p>
      Gentile Utente, per accedere alla piattaforma telematica occorre preliminarmente accettare il
      “Regolamento per l’utilizzo del sistema telematico di acquisto” dell’Agenzia nazionale per
      l’attrazione degli investimenti e lo sviluppo d’impresa S.p.A. (INVITALIA) ed il Codice Etico di
      INVITALIA.
    </p>
    <div class="card card-big shadow p-4 no-after pb-0 mt-4" alt="Leggere la privacy prima di accettare">
      <div class="card-body p-0 text-justify">
        <div id="scrollingPrivacy" class="overflow-auto" style="max-height: 300px;">
          <app-informativa-privacy></app-informativa-privacy>
          <p>
            Letta l'Informativa che precede, il sottoscritto:
          </p>
          <p>
            DICHIARA DI ESSERE STATO CORRETTAMENTE INFORMATO in ordine all'esistenza
            e altrattamento dei dati personali ad esso relativi e dichiara di manlevare i Titolari per i danni
            derivati a terzi i cui dati personali l'Utente abbia inserito su propria esclusiva iniziativa nella
            Richiesta di Adesione, nonché di esimere da qualsiasi responsabilità i Titolari in ordine agli
            adempimenti richiesti dalla legge.
          </p>
          <p>
            Il sottoscritto DICHIARA di aver preso visione della Privacy Policy di Invitalia, accessibile
            al seguente <a target="_blank" href="https://www.invitalia.it/privacy-policy">link</a>.
          </p>
          <p>
            Il sottoscritto DICHIARA di accettare il Codice Etico di Invitalia, accessibile al seguente
            <a target="_blank"
              href="https://www.invitalia.it/-/media/invitalia/documenti/trasparenza/codice-etico-e-modello-organizzativo/codice-etico-invitalia-2023.pdf">link</a>.
          </p>
          <p>
            Il sottoscritto DICHIARA di accettare il Regolamento di Utilizzo della piattaforma,
            accessibile al seguente
            <a target="_blank" [href]="urlRegolamento" download="regolamentoPU.pdf">link</a>.
          </p>
          <a href="/" id="endPrivacy" onclick="return false"> Data ultimo aggiornamento: agosto 2024</a>
        </div>
        <div class="form-check">
          <input id="checkbox1" formControlName="privacy" type="checkbox">
          <label for="checkbox1">Accetti termini e condizioni?</label>
        </div>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end mt-4 mb-4">
    <button type="button" itButton="primary" [disabled]="!form.enabled || form.invalid || ente.isSolaLettura" (click)="save()">
      Salva
    </button>
  </div>
</div>
